// project-imports
import { VerticalDrawer } from '../Drawer/vertical';

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

export default function MainDrawer() {
  return <VerticalDrawer />;
}
